import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { NBSteppers } from "../../../Resource/Contents";
import { nbSippIncomePaymentDetailsLabels } from "../../../Resource/Contents";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import IncomePayment from "./IncomePayment";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { setValueByKey } from "../../../../../../../Shared/Table/Utils/TableUtils";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import IncomeBankDetails from "../../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    data: ApplyModel;
    incomeOnly?: boolean;
}

interface IIncomePaymentDetailsState {}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { onChange, data } = this.props;
        super.componentDidMount();
    }
    private hasDrawdown(data: ApplyModel): boolean {
        return !!data?.PensionApply?.DrawdownModel?.InstructionId;
    }

    private hasTransfer(data: ApplyModel): boolean {
        return data?.PensionApply?.PensionTransfers?.length > 0;
    }
    private handleOnChange(changes) {
        const { onChange, data } = this.props;
        let _data = JSON.parse(JSON.stringify(data?.PensionApply));
        if (this.hasDrawdown(data)) {
            for (const key in changes) {
                _data = setValueByKey(_data, `DrawdownModel.Income.${key}`, changes[key]);
            }
        }
        if (this.hasTransfer(data)) {
            _data.PensionTransfers = _data?.PensionTransfers?.map((e) => {
                for (const key in changes) {
                    e = setValueByKey(e, `IncomePaymentDetails.DrawdownIncome.AnnualIncome.${key}`, changes[key]);
                }
                return e;
            });
        }
        this.onDataChange(onChange, _data, data, "PensionApply");
    }

    public render(): JSX.Element {
        const { data, incomeOnly, onChange, showErrorMsgPopUp } = this.props;
        const isImmediateTaxFreeLumpSum =
            data?.SelectedProducts?.find((ele) => ele.SubAccountType == SubAccountType.JuniorSipp)
                ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        const postTransfer = (data?.PensionApply?.PensionTransfers || []).find(
            (ele) => ele.PensionSource == PensionArrangementType.Crystallised
        );
        const incomeBankDetails =
            postTransfer?.IncomePaymentDetails?.DrawdownIncome?.AnnualIncome?.IncomePaymentAllocations ||
            data?.PensionApply?.DrawdownModel?.Income?.IncomePaymentAllocations;
        return (
            <div>
                <h2>{NBSteppers.incomePaymentDetails}</h2>

                {data?.PensionApply?.DrawdownModel?.DrawdownType === DrawdownType.Regular && (
                    <div className="row">
                        <div className="col-12">
                            <RadiosEditor
                                cssWrapper="rg-inline mb-16"
                                label={nbSippIncomePaymentDetailsLabels.taxableIncomeRequiredInAddition}
                                selected={
                                    data?.PensionApply?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition || false
                                }
                                options={[true, false]}
                                getText={(v) => (v ? "Yes" : "No")}
                                onChange={(v) => {
                                    this.handleOnChange({ TaxableIncomeRequiredInAddition: v });
                                }}
                            />
                        </div>
                    </div>
                )}
                {((data?.PensionApply?.DrawdownModel &&
                    (data.PensionApply.DrawdownModel.DrawdownType !== DrawdownType.Regular ||
                        data?.PensionApply?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition)) ||
                    (data?.PensionApply?.PensionTransfers || []).some(
                        (e) => e?.PensionSource == PensionArrangementType.Crystallised
                    )) && (
                    <IncomePayment
                        data={data?.PensionApply}
                        onChange={(changes) => {
                            this.onDataChange(onChange, changes, data, "PensionApply");
                        }}
                        onRef={(ref) => this.appendChild(ref)}
                        showErrorMsgPopUp={(msg, isShow) => showErrorMsgPopUp(msg, isShow)}
                        onIncomeChange={(changes) => this.handleOnChange(changes)}
                        isITFC={isImmediateTaxFreeLumpSum}
                    />
                )}
                <IncomeBankDetails
                    data={incomeBankDetails}
                    onChange={(v) => {
                        this.handleOnChange({ IncomePaymentAllocations: v });
                    }}
                    showErrorMsgPopUp={(msg, isShow) => showErrorMsgPopUp(msg, isShow)}
                    onRef={(ref) => this.appendChild(ref)}
                    showPropotionOfPcls={!incomeOnly}
                    showPropotionOfIncome={
                        postTransfer
                            ? false
                            : data?.PensionApply?.DrawdownModel?.DrawdownType != DrawdownType.Regular ||
                              data?.PensionApply?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition
                    }
                    bankAccountInstructions={data?.BankAccountInstructions}
                    allBankAccounts={data?.AllBankAccounts}
                    OwnerHierarchyId={data?.OwnerHierarchyId}
                    onChangeBankAccountInstructions={(changes) => {
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }}
                />
            </div>
        );
    }
}
